import { render } from "./Dashboard.vue?vue&type=template&id=0ad6a014"
import script from "./Dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./Dashboard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/dashboard/Dashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ad6a014"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ad6a014', __exports__)) {
    api.reload('0ad6a014', __exports__)
  }
  
  module.hot.accept("./Dashboard.vue?vue&type=template&id=0ad6a014", () => {
    api.rerender('0ad6a014', render)
  })

}


export default __exports__